<template>
  <div class="user-info">
    <div class="user-avatar">
      <img class="avatar-css" :src="user.avatar" alt="" />
    </div>
    <div class="user-nickname">
      {{ user.nickname }}
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
interface IUser {
  user_id: number;
  nickname: string;
  avatar: string;
}
@Component({})
export default class UserInfo extends Vue {
  user: IUser = {
    user_id: -1,
    nickname: '',
    avatar: '',
  };
  async fetchUserInfo() {
    const { unionid, activity_class_id } = this.$route.query;
    const { id } = this.$route.params;
    const {
      data: { user_id, nickname, avatar },
    } = await window.apis.getInviteUser({
      id,
      unionid,
      production_id: id,
    });

    this.user = {
      user_id,
      nickname,
      avatar,
    };

    this.$emit('getUserInfo', {
      activity_class_id: activity_class_id,
      InviterUserId: user_id,
    });
  }
  mounted() {
    this.fetchUserInfo();
  }
}
</script>

<style scoped lang="scss">
.user-info {
  display: flex;
  margin-top: 52px;
  .user-avatar {
    width: 132px;
    text-align: right;
    .avatar-css {
      display: inline-block;
      width: 80px;
      height: 80px;
      border-radius: 48px;
    }
  }

  .user-nickname {
    margin-left: 21px;
    color: #ffffff;
    font-weight: 600;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }
}
</style>